export const Shapes = () => (
    <div class="shapes">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 913.059 813.081">

            <g id=" Group_218" data-name="Group 218" transform="translate(1270.13 5214.486) rotate(30)">
                < g transform="matrix(0.87, -0.5, 0.5, 0.87, -3707.21, -3880.81)" filter="url(#Rectangle_2)">
                    <rect id=" Rectangle_2-2" data-name=" Rectangle 2" width="8" height="38" rx="4" transform="translate(870.14 55.29) rotate(30)" fill="#0E76A8" />
                </g >
                <g transform=" matrix(0.87, -0.5, 0.5, 0.87, -3707.21, -3880.81)" filter="url(#Rectangle_3)">
                    <rect id=" Rectangle_3-2" data-name=" Rectangle 3" width="8" height="38" rx="4" transform="translate(845.65 67.71) rotate(-60)" fill="#0E76A8" />
                </g >
            </g >
            <g transform=" matrix(1, 0, 0, 1, 0, 0)" filter="url(#Polygon_1)">
                <g id=" Polygon_1-2" data-name=" Polygon 1" transform="translate(32.5 571.27) rotate(30)" fill="none">
                    < path d="M27.5, 0, 55, 47H0Z" stroke="none" />
                    < path d="M 27.5 9.900753021240234 L 8.718524932861328 42 L 46.28147506713867 42 L 27.5 9.900753021240234 M 27.5 0 L 55 47 L 0 47 L 27.5 0 Z" stroke="none" fill="#EDA90F" />
                </g >
            </g >
            <g transform=" matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_2)">
                <g id=" Ellipse_2-2" data-name=" Ellipse 2" transform="translate(876.06 773.08)" fill="none" stroke="#E19BA4" stroke-width="5" >
                    <circle cx="14" cy="14" r="14" stroke="none" />
                    < circle cx="14" cy="14" r="11.5" fill="none" />
                </g >
            </g >
            <g transform=" matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_4)">
                <g id=" Rectangle_4-2" data-name=" Rectangle 4" transform="translate(181.93 32.1) rotate(-59)" fill="none" stroke="#47AD7E" stroke-width="4" >
                    <rect width="30.455" height="30.455" stroke="none" />
                    < rect x="2" y="2" width="26.455" height="26.455" fill="none" />
                </g >
            </g >
        </svg >
    </div>
)